import PermissionDenied from "@/components/Common/PermissionDenied";
import Invoices from "@/components/Invoices/Invoices";
import {useIsAdmin, useSelectedCompanyId} from "@/hooks/useUserHooks";
import {createFileRoute} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_company/company/$companyId/invoices")({
  component: CompanyInvoices,
  params: {
    parse: raw => ({companyId: +raw.companyId}),
    stringify: params => ({companyId: params.companyId?.toString()}),
  },
});

function CompanyInvoices() {
  const navigate = Route.useNavigate();
  const {companyId} = Route.useParams();
  const isAdmin = useIsAdmin();
  const selectedCompanyId = useSelectedCompanyId();
  const isViewingSelf = selectedCompanyId === +companyId;

  if (!isAdmin && !isViewingSelf) {
    return <PermissionDenied />;
  }

  return <Invoices onBack={() => navigate({to: "/company/$companyId", params: {companyId}})} />;
}
